import { User, UserManager } from "oidc-client-ts";
import { Id } from "@planzone/dto";

type Response = {
  access_token: string;
  refresh_token: string;
  expires_in: number;
};

const casUrl = process.env.CAS_CLIENT_ID;

export class OidcLogin {
  parameters = {
    stsAuthority: "/cas/oidc/",
    clientId: `${casUrl}`,
    clientRoot: `${window.location.href}`,
    clientScope: "openid profile email api",
    apiRoot: "/uaa/api/",
  };

  public userManager: UserManager;

  constructor(planzoneUuid?: Id) {
    this.userManager = new UserManager({
      authority: this.parameters.stsAuthority,
      client_id: this.parameters.clientId,
      redirect_uri: this.parameters.clientRoot,
      silent_redirect_uri: this.parameters.clientRoot,
      post_logout_redirect_uri: `${this.parameters.clientRoot}${
        planzoneUuid === "57ec7e80-dcbb-49af-b11f-665fa6e545c1"
          ? "?service=ocp"
          : planzoneUuid === "de716f9e-6629-491a-8846-261bdeb9c710"
            ? "?service=sgcdv"
            : planzoneUuid === "4253b396-f29e-4f8c-bc41-47fb0d9595f7"
              ? "?service=cegelec"
              : ""
      }`,
      response_type: "code",
      scope: this.parameters.clientScope,
    });
  }

  public login(): Promise<void> {
    return this.userManager.signinRedirect();
  }

  public accessToken(): Promise<Response> {
    return this.userManager.signinRedirectCallback().then((user) => ({
      access_token: `${user?.access_token || ""}`,
      refresh_token: `${user?.refresh_token || ""}`,
      expires_in: user?.expires_in || 0,
    }));
  }

  public renewToken(): Promise<User | null> {
    return this.userManager.signinSilent();
  }

  public logout(): Promise<void> {
    return this.userManager.signoutRedirect();
  }
}
